export default __webpack_public_path__ + "static/media/logo.48faf4ef.jpg";